import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VExpansionPanels,{model:{value:(_vm.openedPanel),callback:function ($$v) {_vm.openedPanel=$$v},expression:"openedPanel"}},[_c(VExpansionPanel,[_c(VExpansionPanelHeader,[_c('h6',[_vm._v(_vm._s(_vm.title))])]),_c(VExpansionPanelContent,{staticClass:"mx-n7 mt-n6"},[_vm._t("content",function(){return [_c('p',[_vm._v("Content")])]})],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }